<app-scaffold
  icon="streamline:app-window-warning"
  [title]="'ERROR.UNSUPPORTED_BROWSER.TITLE' | translate"
  [content]="'ERROR.UNSUPPORTED_BROWSER.CONTENT' | translate"
>
</app-scaffold>
